<template>
  <div id="footer" class="container-fluid">
    <div class="row-box">
      <el-row>
        <el-col :xs="12" :sm="8" :md="4" :lg="4" :xl="4">
          <dl>
            <dt class="address_tel_fax">关于我们</dt>
            <dd><a href="/about#m1">公司简介</a></dd>
            <dd><a href="/about#m2">企业文化</a></dd>
            <dd><a href="/about#m3">核心优势</a></dd>
            <dd class="dd-bottom"><a href="/about#m4">荣誉资质</a></dd>
          </dl>
        </el-col>
        <el-col :xs="12" :sm="8" :md="4" :lg="4" :xl="4">
          <dl>
            <dt class="address_tel_fax">产品服务</dt>
            <dd><a href="/solution/elinkht">大宗一站通平台</a></dd>
            <dd><a href="/solution/digitization">数智化解决方案</a></dd>
            <dd class="dd-bottom">
              <a href="/solution/it-services">信息技术服务</a>
            </dd>
          </dl>
        </el-col>
        <el-col :xs="12" :sm="8" :md="4" :lg="4" :xl="4">
          <dl>
            <dt class="address_tel_fax">企业资讯</dt>
            <dd><a href="/company/dynamic">企业动态</a></dd>
            <dd class="dd-bottom"><a href="/company/news">行业新闻</a></dd>
          </dl>
        </el-col>
        <el-col :xs="24" :sm="24" :md="12">
          <el-row gutter="16">
            <el-col :xs="24" :sm="12" :md="12">
              <dl>
                <dt class="address_tel_fax">联系我们</dt>
                <dd>service@chinaresc.com</dd>
                <dd>广东省深圳市南山区沙河西路 3157 号智谷产业园 F 座 19 楼</dd>
                <dd class="dd-bottom phone">400-699-2024</dd>
              </dl>
            </el-col>
            <el-col :xs="24" :sm="12" :md="12">
              <dl>
                <dt class="address_tel_fax">微信公众号</dt>
                <dd class="code-box">
                  <div class="centent">
                    <img
                      src="@/assets/img/home/weixin.png"
                      alt=""
                      class="weixin"
                    />
                    <div class="code-text">
                      <div>微信扫一扫</div>
                      <div>关注中资国恒科技公众号</div>
                    </div>
                  </div>
                </dd>
              </dl>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </div>
    <div class="footer-b">
      <span class="bah">
        ©Copyright 2023 中资国恒科技有限公司
        <a href="https://beian.miit.gov.cn/" target="_blank" rel="nofollow">
          粤 ICP 备 2022112699 号
        </a></span
      >
    </div>
  </div>
</template>
<script>
export default {
  name: 'Footer',
  data() {
    return {}
  }
}
</script>
<style scoped lang="less">
#footer {
  width: 100%;
  height: 100%;
  margin: 0 auto;
  padding: 0 20px;
  color: #d3d3d3;
  background: #1e2328;
  // background: hsl(248, 80%, 8%);
}
.email {
  font-size: 14px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: #f1f3f5;
  line-height: 20px;
  margin: 16px 0;
}
.row-box {
  margin: 0px auto;
  padding: 40px 0;
  max-width: 1200px;
  border-bottom: 1px solid #343059;
  dl {
    margin: 0;
    dt {
      font-size: 20px;
      font-family: PingFang SC-Medium, PingFang SC;
      font-weight: 400;
      color: #ffffff;
      line-height: 28px;
    }
    dd {
      font-size: 14px;
      font-family: PingFang SC-Regular, PingFang SC;
      font-weight: 400;
      color: #f1f3f5;
      line-height: 20px;
      margin: 16px 0;
      &:hover {
        cursor: pointer;
        color: #075ffc;
      }
      a {
        &:hover {
          cursor: pointer;
          color: #075ffc;
        }
      }
    }
    .dd-bottom {
      margin: 0;
    }
    .phone {
      font-size: 20px;
      font-family: DIN-Medium, DIN;
      font-weight: 500;
      color: #f1f3f5;
      line-height: 28px;
    }
    .code-box {
      background: #282d3c;
      border-radius: 4px 4px 4px 4px;
      &:hover {
        color: #f1f3f5;
        cursor: context-menu !important;
      }
      .centent {
        display: flex;
        padding: 1.2rem 0 1.2rem 1.2rem;
        .code-text {
          padding: 2rem 1.6rem 2rem 0.8rem;
        }
      }
    }
  }
}
.footer-b {
  text-align: center;
  height: 20px;
  margin: 24px auto;
  font-size: 14px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: #878f9b;
  line-height: 20px;
  .bah {
    a {
      color: #878f9b;
      &:hover {
        color: #075ffc;
        text-decoration: none;
      }
    }
  }
}
.address_tel_fax {
  font-weight: 500 !important;
  color: #878f9b;
  font-size: 16px;
  // margin-bottom: 16px;
}
.weixin {
  width: 80px;
  height: 80px;
}
a {
  color: #f1f3f5;
  &:hover {
    color: #409eff;
    text-decoration: none;
  }
}

@media (max-width: 997px) {
  .address_tel_fax {
    margin: 10px 0px;
  }

  .footer-b {
    margin: 10px auto;
  }
}
</style>
